<template>
  <g transform="matrix(1 0 0 1 0 0)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.14286 1.86307L11.3311 5.09165L12.2403 4.17102L8.56066 0.444893C7.97487 -0.148296 7.02513 -0.148299 6.43934 0.444892L2.75972 4.17102L3.66885 5.09165L6.85714 1.86307V10.7072H8.14286V1.86307ZM0 14.6131V9.40521H1.28571V14.6131C1.28571 15.2123 1.76541 15.698 2.35714 15.698H12.6429C13.2346 15.698 13.7143 15.2123 13.7143 14.6131V9.40521H15V14.6131C15 15.9313 13.9447 17 12.6429 17H2.35714C1.05533 17 0 15.9313 0 14.6131Z"
      fill="#192C27"
    />
  </g>
</template>
